<template>
  <div class="UserPackage-list-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-dropdown
          id="dropdown-right dropdown-form"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider> </b-dropdown-divider>
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="3">
                  <basic-input
                    label="Mã"
                    placeholder="Nhập mã"
                    name="code"
                    :value.sync="filter.code"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Tên"
                    placeholder="Nhập tên"
                    name="name"
                    :value.sync="filter.name"
                  >
                  </basic-input>
                </b-col>
                <!-- Cấp độ đang luôn truyền 1 khi tạo gói nên lọc theo nó vô nghĩa -->
                <!-- <b-col cols="3">
                  <basic-select
                    label="Cấp độ"
                    placeholder="Nhập cấp độ"
                    name="level"
                    :options="levels"
                    :value.sync="filter.level"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Cấp độ"
                  ></basic-select>
                </b-col> -->

                <!-- <b-col cols="3">
                  <basic-input
                    label="Giá bán"
                    placeholder="Nhập giá bán"
                    name="saleMoney"
                    :value.sync="filter.saleMoney"
                  >
                  </basic-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <basic-input
                    label="Ngày bắt đầu"
                    placeholder="Nhập ngày bắt đầu"
                    name="startDate"
                    :value.sync="filter.startDate"
                  >
                  </basic-input>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Ngày kết thúc"
                    placeholder="Nhập ngày kết thúc"
                    name="endDate"
                    :value.sync="filter.endDate"
                  >
                  </basic-input>
                </b-col> -->
                <b-col cols="3">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Chọn trạng thái"
                    name="status"
                    :options="status"
                    :value.sync="filter.status"
                    track-by="value"
                    value-label="text"
                    data-vv-as="Trạng thái"
                  ></basic-select>
                </b-col>
                <b-col cols="3">
                  <basic-input
                    label="Số điện thoại"
                    placeholder="Nhập số điện thoại"
                    name="phoneNumber"
                    :value.sync="filter.phoneNumber"
                  >
                  </basic-input>
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider> </b-dropdown-divider>
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="resetRequest"
            >
              <span class="svg-icon">
                <inline-svg
                  src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button
              class="btn ml-2"
              href="#"
              tabindex="0"
              @click="searchRequest"
            >
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="createItem"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
          </span>
          Thêm mới
        </b-button>
        <b-button
          v-if="isInsertPermission"
          class="btn btn-success ml-2"
          type="button"
          @click="importItems"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/upload-cloud.svg" />
          </span>
          Thêm theo danh sách
        </b-button>
        <modal-import :packageData="packageData" @reload-data="loadData" />
      </template>
    </basic-subheader>
    <b-overlay :show="loading">
      <b-container fluid class="UserPackage-list-page__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="column"
                  :data="data"
                  :paging="paging"
                  :tableAction="false"
                  :selectAction="false"
                  :searchAction="false"
                  @search="searchRequest"
                  @reset="resetRequest"
                  @sortBy="sortRequest"
                >
                  <template v-slot:body="{ item }">
                    <!-- <td :class="getPositionClass(item.code)">
                      {{ item.code }}
                    </td> -->
                    <td :class="getPositionClass(item.name)">
                      {{ item.name }}
                      <span
                        v-if="isAiMode(item)"
                        class="ai-badge"
                        title="Gói tạo bằng AI Mode — nội dung nhắc nhở do AI soạn, coach duyệt"
                      >AI</span>
                    </td>
                    <td>
                      {{ item.phoneNumber }}
                    </td>

                    <td :class="getPositionClass(item.servicePackageId)">
                      {{ getNameServicePackage(item.servicePackageId) }}
                    </td>
                    <!-- <td :class="getPositionClass(item.saleMoney)">
                      {{ item.saleMoney }}
                    </td> -->

                    <td :class="getPositionClass(item.startDate)">
                      {{ convertTimestampToDate(item.startDate) }}
                    </td>
                    <!-- <td :class="getPositionClass(item.endDate)">
                      {{ convertTimestampToDate(item.endDate) }}
                    </td> -->
                    <td
                      class="text-center"
                      :class="getPositionClass(item.level)"
                    >
                      {{ item.level }}
                    </td>
                    <td>
                      {{ checkReminder(item.reminderMethod) }}
                    </td>
                    <td style="text-align: -webkit-center">
                      <div class="status" :class="getStatus(item.status)">
                        {{ statusText(item.status) }}
                      </div>
                    </td>
                    <td>
                      <action-dropdown
                        :value="item"
                        :show_edit="false"
                        :show_delete="false"
                        :show_copy="false"
                        :show_view="isViewPermission"
                        :boundary="data.length > 2 ? 'scrollParent' : 'window'"
                        @view="viewItem"
                      >
                        <b-dropdown-text
                          v-if="isViewPermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="viewActivity(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-primary"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/send.svg"
                              />
                            </span>
                            <span class="success navi-text text-primary">
                              {{ 'Xem hoạt động' }}
                            </span>
                          </a>
                        </b-dropdown-text>
                        <!--
                          Chỉ gói AI Mode đã chạy mới có cái để theo dõi: gói thường không
                          qua vòng duyệt, gói nháp thì chưa có dòng lịch gửi nào.
                        -->
                        <b-dropdown-text
                          v-if="isViewPermission && isAiMode(item) && !isDraft(item.status)"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <a
                            class="navi-link cursor-pointer"
                            @click="openReminderTracking(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-primary"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/pulse.svg"
                              />
                            </span>
                            <span class="success navi-text text-primary">
                              Theo dõi nhắc nhở
                            </span>
                          </a>
                        </b-dropdown-text>
                        <!--
                          Gói nháp chưa có hoạt động lẫn job nào, đổi trạng thái là tạo ra
                          gói "hoạt động" nhưng chết — BE chặn, ở đây không hiện nút luôn.
                          Việc cần làm với nó là vào làm tiếp cho xong.
                        -->
                        <b-dropdown-text
                          v-if="isDraft(item.status)"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <hr class="my-2" />
                          <a
                            class="navi-link cursor-pointer"
                            @click="continueAiMode(item)"
                          >
                            <span
                              class="menu-icon svg-icon svg-icon-sm text-success"
                            >
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/send.svg"
                              />
                            </span>
                            <span class="success navi-text text-success">
                              Tiếp tục AI Mode
                            </span>
                          </a>
                        </b-dropdown-text>

                        <!-- Nút đổi trạng thái Hoạt động / Không hoạt động đã ẩn.
                             deleteItem() và changeStatus() giữ nguyên bên dưới để bật
                             lại được ngay khi cần, khỏi dựng lại từ đầu. -->

                        <!-- Xoá hẳn (soft-delete hàng loạt qua SP), khác với đổi trạng thái
                             ở trên — hiện ở MỌI trạng thái kể cả Nháp. -->
                        <b-dropdown-text
                          v-if="isDeletePermission"
                          tag="div"
                          class="navi-item cursor-pointer"
                        >
                          <hr class="my-2" />
                          <a
                            class="navi-link cursor-pointer"
                            @click="openCoachNote(item)"
                          >
                            <span class="menu-icon svg-icon svg-icon-sm text-success">
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/edit.svg"
                              />
                            </span>
                            <span class="navi-text text-success">Coach Note</span>
                          </a>
                          <hr class="my-2" />
                          <a
                            class="navi-link cursor-pointer"
                            @click="hardDeleteItem(item)"
                          >
                            <span class="menu-icon svg-icon svg-icon-sm text-danger">
                              <inline-svg
                                class="svg-icon"
                                src="/media/svg/icons/Neolex/Basic/trash.svg"
                              />
                            </span>
                            <span class="success navi-text text-danger">
                              Xoá
                            </span>
                          </a>
                        </b-dropdown-text>
                      </action-dropdown>
                    </td>
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TAG_TYPE } from '../../../core/plugins/constants';
import moment from 'moment';
import { convertDateToTimestamp } from '../../../core/mixins';
export default {
  props: {},
  name: 'UserPackageList',
  components: {
    'modal-import': () => import('./components/FormUserPackageImport.vue'),
  },
  data() {
    return {
      levels: [
        {
          text: 'Level 0',
          value: 0,
        },
        {
          text: 'Level 1',
          value: 1,
        },
        {
          text: 'Level 2',
          value: 2,
        },
        {
          text: 'Level 3',
          value: 3,
        },
        {
          text: 'Level 4',
          value: 4,
        },
      ],
     
      status: [
        {
          value: 0,
          text: 'Hoạt động',
        },
        {
          value: 1,
          text: 'Không hoạt động',
        },
        {
          value: 3,
          text: 'Nháp',
        },
      ],
      paging: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      filter: {
        code: null,
        name: null,
        level: null,
        servicePackageId: null,
        saleMoney: null,
        status: null,
        startDate: null,
        endDate: null,
        phoneNumber: null,
      },
      sort: {
        by: null,
        order: null,
      },
      column: [
        // {
        //   key: 'code',
        //   label: 'Mã',
        //   sortable: false,
        //   style: 'width: 10%',
        // },
        {
          key: 'name',
          label: 'Tên',
          sortable: false,
          style: 'width: 15%',
        },
        {
          key: 'phoneNumber',
          label: 'Số điện thoại',
          sortable: false,
          style: 'width: 10%',
        },

        {
          key: 'servicePackageId',
          label: 'Gói dịch vụ',
          sortable: false,
          style: 'width: 20%',
        },
        // {
        //   key: 'saleMoney',
        //   label: 'Giá tiền',
        //   sortable: false,
        //   style: 'width: 10%',
        // },
        {
          key: 'startDate',
          label: 'Ngày bắt đầu',
          sortable: false,
          style: 'width: 10%',
        },
        // {
        //   key: 'endDate',
        //   label: 'Ngày kết thúc',
        //   sortable: false,
        //   style: 'width: 10%',
        // },
        {
          key: 'level',
          label: 'Cấp độ',
          sortable: false,
          style: 'width: 10%',
          class: 'text-center',
        },

        {
          key: 'reminderMethod',
          label: 'Loại nhắc nhở',
          sortable: false,
          style: 'width: 10%',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          style: 'width: 10%',
          class: 'text-center',
        },
        {
          key: 'action',
          label: '',
          sortable: false,
          style: 'width: 5%',
        },
      ],
      data: [],
      loading: false,
      selectedItems: [],
      packageData: [],
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
    isAdmin() {
      let roles = this.currentUser?.roles;
      if (roles && roles.length) {
        return roles.includes('Admin');
      } else {
        return false;
      }
    },

    searchParams() {
      const payload = this.removeEmpty({
        code: this.filter.code,
        name: this.filter.name,
        level: this.filter.level,
        servicePackageId: this.filter.servicePackageId,
        saleMoney: this.filter.saleMoney,
        status: this.filter.status,
        startDate: convertDateToTimestamp(this.filter.startDate),
        endDate: this.filter.endDate,
        phoneNumber: this.filter.phoneNumber,

        page: this.paging.page,
        size: this.paging.pageSize,
      });
      const params = new URLSearchParams();
      for (const property in payload) {
        params.append(property, payload[property]);
      }
      return params;
    },
    phoneNumbers() {
      const cache = {};
      return this.items.reduce((acc, item) => {
        acc[item.accountId] =
          cache[item.accountId] || this.fetchPhoneNumber(item.accountId);
        return acc;
      }, {});
    },
  },
  watch: {
    'paging.page'() {
      this.loadData();
    },
    'paging.pageSize'() {
      this.loadData();
    },
  },
  methods: {
    checkReminder(method) {
      switch (method) {
        case 0:
          return 'Zalo App';
        case 1:
          return 'DiaB App';
        case 2:
          return 'DiaB App, Zalo App';
        case 3:
          return 'Không gửi thông báo';
        default:
          return 'Không gửi thông báo';
      }
    },
    convertTimestampToDate(timestamp) {
      return timestamp ? moment(timestamp * 1000).format('DD/MM/YYYY') : null;
    },
    searchRequest() {
      this.loadData();
      document.body.click();
    },
    resetRequest() {
      this.filter.code = null;
      this.filter.name = null;
      this.filter.level = null;
      this.filter.servicePackageId = null;
      this.filter.saleMoney = null;
      this.filter.status = null;
      this.filter.startDate = null;
      this.filter.endDate = null;
      this.filter.phoneNumber = null;

      this.loadData();
      document.body.click();
    },
    sortRequest(sortData) {
      this.sort = {
        by: sortData.column,
        order: sortData.order,
      };
      this.loadData();
    },
    viewItem(item) {
      this.$router.push({
        name: 'user_package_view',
        params: {
          item: item,
          package: this.packageData,
        },
      });
    },
    openCoachNote(item) {
      const phone = item.phoneNumber?.replace(/^\+84/, '0') ?? '';
      this.$router.push({
        name: 'coach_note_detail',
        params: { userPackageId: item.id, phoneNumber: phone },
      });
    },
    viewActivity(item) {
      this.$router.push({
        name: 'tran_user_package_view',
        params: {
          id: item.accountId,
        },
      });
    },
    // Mở màn theo dõi đã khoá sẵn vào gói này. Truyền kèm tên gói để màn kia hiện
    // được đang lọc theo cái gì ngay cả khi khoảng ngày đang xem không có dòng nào.
    openReminderTracking(item) {
      this.$router.push({
        name: 'reminder_tracking_list',
        query: { userPackageId: item.id, label: item.name || '' },
      });
    },
    // Mở thắng màn gợi ý AI, không bắt người dùng tự tìm nút trong trang sửa
    continueAiMode(item) {
      this.$router.push({
        name: 'user_package_edit',
        params: { id: item.id, form_type: 'edit' },
        query: { ai: '1' },
      });
    },
    editItem(item) {
      this.$router.push({
        name: 'user_package_edit',
        params: {
          id: item.id,
          form_type: 'edit',
        },
      });
    },
    // TODO: Lanh - If want to new sreen for insert
    // createItem() {
    //   this.$router.push({
    //     name: 'user_package_create',
    //   });
    // },
    getPositionClass(value) {
      if (typeof value === 'number' && !isNaN(value)) {
        return 'text-left'; // Number
      } else if (typeof value === 'string') {
        return 'text-left'; // String
      } else if (
        (Object.prototype.toString.call(value) === '[object Date]' &&
          !isNaN(value)) ||
        !isNaN(Date.parse(value))
      ) {
        return 'text-left'; // Date or DateTime
      } else {
        return 'text-left'; // Unidentified
      }
    },
    createItem() {
      this.$router.push({
        name: 'user_package_edit',
        params: {
          form_type: 'create',
        },
      });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        this.veeFields[ref].dirty &&
        this.veeFields[ref].validated
      ) {
        return this.veeFields[ref].valid;
      }
      return null;
    },
    importItems() {
      this.$bvModal.show('modal-import');
    },
    deleteItem(item) {
      let btn = item.status == 0 ? 'btn-active' : 'btn-inactive';
      let textStatusB = item.status ? 'Hoạt động' : 'Không hoạt động';
      let textStatusA = !item.status ? 'Hoạt động' : 'Không hoạt động';
      this.$swal({
        title: '',
        text: `Bạn có chắc chắn muốn chuyển trạng thái ${textStatusB} thành ${textStatusA} không?`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Chắc chắn',
            value: true,
            visible: true,
            className: `btn ${btn}`,
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            // inactive all
            this.changeStatus(item);
          }
        }.bind(this),
      );
    },
    // Xoá hẳn — khác changeStatus (chỉ đổi cờ status). Cho phép ở mọi trạng
    // thái kể cả Nháp, vì gói nháp bỏ hoang cũng cần dọn được ngay, không đợi
    // job quét 48h.
    hardDeleteItem(item) {
      this.$swal({
        title: '',
        text: `Xoá hẳn gói "${item.name}"? Toàn bộ chương trình/hoạt động/lịch nhắc của gói này sẽ bị xoá theo, không khôi phục được.`,
        icon: '/media/svg/icons/SweetAlert/alert-triangle-red.svg',
        buttons: {
          cancel: {
            text: 'Hủy',
            value: false,
            visible: true,
            className: 'btn btn-secondary',
            closeModal: true,
          },
          confirm: {
            text: 'Xoá hẳn',
            value: true,
            visible: true,
            className: 'btn btn-danger',
            closeModal: true,
          },
        },
      }).then(
        function (result) {
          if (result) {
            this.confirmHardDelete(item);
          }
        }.bind(this),
      );
    },
    async confirmHardDelete(item) {
      this.$store.commit('context/setLoading', true);

      const res = await this.$api.delete(
        `TranUserPackage?userPackageId=${item.id}`,
      );
      const { error } = res;
      if (error) {
        this.$store.commit('context/setLoading', false);
        return this.$toastr.e({
          title: 'Lỗi !',
          msg: error.message || 'Xoá thất bại',
        });
      }

      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Đã xoá gói',
      });
      this.$store.commit('context/setLoading', false);

      // Xoá thật chạy nền qua Hangfire (enqueue xong API trả về ngay, chưa
      // xoá xong) — loadData() ở đây gọi lại server gần như chắc chắn fetch
      // trước khi job chạy xong, record vẫn còn y nguyên. Bỏ dòng khỏi list
      // tại chỗ thay vì fetch lại, tránh đua với job.
      this.data = this.data.filter((x) => x.id !== item.id);
      this.paging.total = Math.max(0, this.paging.total - 1);
    },
    copyItem(item) {
      this.$router.push({
        name: 'user_package_detail',
        params: {
          form_type: 'copy',
          id: item.id,
        },
      });
    },
    async changeStatus(item) {
      this.$store.commit('context/setLoading', true);
      const formData = new FormData();

      formData.append('status', item.status ? '0' : '1');

      const res = await this.$api.put(
        `/UserPackage/ReActive/${item.id}`,
        formData,
      );
      const { error } = res;
      if (error) {
        if (error.message) {
          this.$store.commit('context/setLoading', false);
          return this.$toastr.e({
            title: 'Lỗi !',
            msg: error.message,
          });
        }
      }
      this.$toastr.s({
        title: 'Thành công !',
        msg: 'Cập nhật thành công',
      });
      this.$store.commit('context/setLoading', false);
      this.loadData();
    },
    async loadData() {
      try {
        this.$store.commit('context/setLoading', true);
        const [res, resService] = await Promise.all([
          this.$api.get('UserPackage', {
            params: this.searchParams,
          }),
          this.$api.get('ServicePackage', { params: { size: 1000 } }),
        ]);
        const { data } = res;
        const { data: dataService } = resService;
        this.data = data.items || [];
        this.paging.total = data.total;
        this.packageData =
          dataService.items.map((el) => ({
            id: el.id,
            name: el.name,
          })) || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    getDataHospital(tags) {
      if (!tags || !tags.length) return null;
      const agencies = tags.filter((el) => el.tag.type === TAG_TYPE.AGENCY);
      return agencies.map((el) => el.tag.name).join(', ');
    },
    // 0 = hoạt động, 1 = không hoạt động, 3 = nháp (gói AI Mode chưa xong).
    // Ép số vì giá trị đi qua JSON có thể về dạng chuỗi.
    toStatusCode(status) {
      return status === null || status === undefined || status === ''
        ? null
        : Number(status);
    },
    isDraft(status) {
      return this.toStatusCode(status) === 3;
    },
    // UserPackageContentMode: 0 = nhắc nhở thường, 1 = AI Mode
    isAiMode(item) {
      return Number(item?.contentMode) === 1;
    },
    statusText(status) {
      const code = this.toStatusCode(status);
      if (code === 3) return 'Nháp';
      return code ? 'Không hoạt động' : 'Hoạt động';
    },
    getStatus(status) {
      const code = this.toStatusCode(status);
      if (code === 3) return 'draft';
      return code ? 'inactive' : 'active';
    },
    searchDebounce(value) {
      this.filter.searchText = value;
      this.resetPaging();
    },
    resetPaging() {
      this.paging.page = 1;
      this.loadData();
    },
    getSearchDataPrepare() {
      this.$api.get('UserPackage/PrepareSearchFormItem').catch((error) => {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      });
    },
    getNameServicePackage(id) {
      const packageData = this.packageData.find((item) => item.id === id);
      return packageData ? packageData.name : id;
    },
  },
  async created() {
    await Promise.all([this.loadData(), this.getSearchDataPrepare()]);
  },
};
</script>
<style lang="scss" scoped>
// Nhãn gắn cạnh tên gói, phân biệt gói AI Mode với gói nhắc nhở thường
.ai-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 10px;
  background: #e7f2ee;
  color: #0a4e3d;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  vertical-align: middle;
}

.status {
  padding: 6px 24px;
  border-radius: 20px;
  color: #fff;
  text-transform: capitalize;
  width: 160px;
  text-align: center;

  &.active {
    background: #21a567;
  }

  &.inactive {
    background: #ff5756;
  }

  // Cùng tông warning hệ thống ($warning: #FFA800), đồng bộ nền đặc/chữ
  // trắng như active/inactive thay vì nền nhạt lệch tông như trước.
  &.draft {
    background: #ffa800;
  }
}

.text-center {
  text-align: left;
  text-overflow: ellipsis;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-overflow {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 850px;
    }
  }
}

.search-input {
  min-width: 220px;
}
</style>
